<script setup lang="ts">
defineProps({
	width: {
		type: String,
		default: '46',
	},
	height: {
		type: String,
		default: '32',
	},
});
</script>
<template>
	<svg
		:width="width"
		:height="height"
		viewBox="0 0 58 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x="0.5"
			y="0.5"
			width="57"
			height="39"
			rx="5.5"
			fill="white"
		/>
		<rect
			x="0.5"
			y="0.5"
			width="57"
			height="39"
			rx="5.5"
			stroke="#F2F4F7"
		/>
		<path
			d="M36.6363 19.9239C37.5218 19.9431 38.4122 19.8848 39.2941 19.9542C40.1872 20.1208 40.4025 21.4729 39.609 21.9157C39.0676 22.2074 38.4245 22.0243 37.8376 22.0758H36.6363V19.9239ZM39.8061 17.4882C40.0028 18.1826 39.3334 18.806 38.6647 18.7104H36.6363C36.6506 18.0556 36.6085 17.3449 36.6569 16.7245C37.4695 16.7474 38.2896 16.6779 39.0974 16.7609C39.4445 16.8481 39.735 17.1335 39.8061 17.4882ZM44.6876 7.19097C44.7254 8.51703 44.6931 9.91319 44.7039 11.2662C44.7014 16.7668 44.7092 22.2673 44.6996 27.7683C44.664 29.8298 42.837 31.6211 40.7898 31.6622C38.7405 31.6706 36.691 31.6635 34.6415 31.6658V23.3499C36.8745 23.3384 39.1087 23.3734 41.3408 23.3325C42.3763 23.2675 43.5105 22.5843 43.5587 21.4448C43.6806 20.3003 42.6017 19.5087 41.5772 19.3837C41.1835 19.3735 41.195 19.2689 41.5772 19.2233C42.5543 19.0121 43.3216 18.0009 43.0341 16.9881C42.7891 15.923 41.6118 15.5107 40.6325 15.5127C38.6358 15.4992 36.6387 15.5108 34.642 15.5069C34.6548 13.9544 34.6151 12.4003 34.6634 10.849C34.8216 8.82466 36.6946 7.15528 38.713 7.1915C40.7048 7.19119 42.6963 7.19119 44.6876 7.19112V7.19097Z"
			fill="url(#paint0_linear_1142_86388)"
		/>
		<path
			d="M12.0775 11.0585C12.1285 9.00026 13.9633 7.22366 16.0079 7.19358C18.0496 7.18729 20.0915 7.19267 22.1332 7.19086C22.1275 14.0773 22.1442 20.9645 22.1247 27.8505C22.0461 29.8838 20.2313 31.6265 18.209 31.6625C16.1635 31.6699 14.1177 31.6636 12.0721 31.6656V23.0694C14.0591 23.5388 16.1427 23.7386 18.1697 23.4273C19.3814 23.2323 20.7071 22.6373 21.1173 21.3802C21.4192 20.305 21.2492 19.1733 21.2941 18.0697V15.5068H17.7862C17.7704 17.2019 17.8185 18.8999 17.7608 20.5929C17.6662 21.6335 16.6357 22.2947 15.6542 22.2594C14.437 22.2723 12.025 21.3773 12.025 21.3773C12.019 18.2014 12.0603 14.2241 12.0775 11.0588V11.0585Z"
			fill="url(#paint1_linear_1142_86388)"
		/>
		<path
			d="M23.4416 16.5407C23.257 16.5799 23.4045 15.9117 23.3573 15.6583C23.3699 14.0557 23.331 12.4514 23.3787 10.85C23.5365 8.81714 25.4239 7.14359 27.4505 7.19118H33.4188C33.4132 14.0776 33.4298 20.9648 33.4104 27.8509C33.3316 29.8841 31.5167 31.6268 29.4943 31.6628C27.4487 31.6706 25.4029 31.664 23.3572 31.666V22.2477C24.7543 23.394 26.6532 23.5725 28.3938 23.5756C29.706 23.5751 31.0106 23.3728 32.2849 23.0702V21.3447C30.8488 22.0605 29.1606 22.5151 27.5687 22.1039C26.4582 21.8275 25.6521 20.7542 25.67 19.6082C25.5414 18.4164 26.24 17.1582 27.4112 16.8039C28.8653 16.3486 30.4501 16.6968 31.8131 17.2886C32.1051 17.4415 32.4015 17.6312 32.2848 17.1431V15.7869C30.0052 15.2445 27.5791 15.0449 25.2889 15.6349C24.626 15.8219 23.9801 16.1055 23.4416 16.5408V16.5407Z"
			fill="url(#paint2_linear_1142_86388)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_1142_86388"
				x1="34.5728"
				y1="18.9051"
				x2="44.6404"
				y2="18.9051"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#58B03A" />
				<stop
					offset="1"
					stop-color="#55B330"
				/>
			</linearGradient>
			<linearGradient
				id="paint1_linear_1142_86388"
				x1="11.8581"
				y1="19.6626"
				x2="21.9682"
				y2="19.6626"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#0F6EB6" />
				<stop
					offset="1"
					stop-color="#006DBA"
				/>
			</linearGradient>
			<linearGradient
				id="paint2_linear_1142_86388"
				x1="23.3425"
				y1="19.1424"
				x2="33.4169"
				y2="19.1424"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#DE0D3D" />
				<stop
					offset="1"
					stop-color="#E30138"
				/>
			</linearGradient>
		</defs>
	</svg>
</template>
